import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const categoryKeys = {
	all: ["categories"] as const,
};

export function useCategories() {
	return useQuery({
		queryKey: categoryKeys.all,
		queryFn: () => api.categories.list(),
	});
}
